import { TranslateService } from '@ngx-translate/core';
import { Direcciones } from './direcciones';

export class DireccionCliente {
    ID: number;
    ID_CLIENTE: number;
    ID_DIRECCION: number;
    Direcciones: Direcciones;

    constructor() { }

    static toModel(json: string): DireccionCliente {
        const data = JSON.parse(json);
        const toReturn = new DireccionCliente();

        toReturn.ID = data.ID;
        toReturn.ID_CLIENTE = data.ID_CLIENTE;
        toReturn.ID_DIRECCION = data.ID_DIRECCION;
        toReturn.Direcciones = Direcciones.toModel(JSON.stringify(data.Direcciones));

        return toReturn;
    }
}

export class Cliente {
    ID: number;
    NOMBRE: string;
    DESCRIPCION: string;
    ACTIVO: boolean;
    Direccion: DireccionCliente[];
    DocumentacionSolicitudes: boolean;

    constructor() { }

    static toModel(json: string): Cliente {
        const data = JSON.parse(json);
        const toReturn = new Cliente();

        toReturn.ID = data.ID;
        toReturn.NOMBRE = data.NOMBRE;
        toReturn.DESCRIPCION = data.DESCRIPCION;
        toReturn.ACTIVO = data.ACTIVO;
        toReturn.Direccion = data.Direccion.map((dir: any) => DireccionCliente.toModel(JSON.stringify(dir)));
        toReturn.DocumentacionSolicitudes = data.DOCUMENTACION_SOLICITUDES;
        return toReturn;
    }
}

export class StatisticsChart {
    client: number;
    clientName: string;
    isTwoDimenssions: boolean;
    results: ChartResults[] | SeriesChart[];

    constructor() { }
}

export class ChartResults {
    name: string;
    series: SeriesChart[];
}

export class SeriesChart {
    name: string;
    value: number;
}

export class Statistics {

    constructor() { }

    public static translateService: TranslateService;
    almostExpiredRequests: StatisticsChart[];
    totalAlmostExpiredRequests: number;
    expiredRequests: StatisticsChart[];
    totalExpiredRequests: number;
    inProgressRequests: StatisticsChart[];
    totalInProgressRequests: number;
    usersAndClientsLastMonthRequests: StatisticsChart[];
    totalUsersAndClientsLastMonthRequests: number;
    pendingEnqueriesDigitalFisicalRequests: StatisticsChart[];
    totalPendingEnqueriesDigitalFisicalRequests: number;

    static toModel(json: string, translateService: TranslateService): Statistics {
        if (!Statistics.translateService) {
            Statistics.translateService = translateService;
        }
        const data = JSON.parse(json);
        const toReturn = new Statistics();
        toReturn.almostExpiredRequests = this.getStatisticsChart(data.SolicitudesAPuntoCaducar, 'ClientName', 'Name', 'NormalUrgente');

        toReturn.totalAlmostExpiredRequests = data.Totalsolicitudeapuntocaducar;

        toReturn.expiredRequests = this.getStatisticsChart(data.SolicitudesCaducadas, 'ClientName', 'Name', 'NormalUrgente');
        toReturn.totalExpiredRequests = data.TotalSolicitudesCaducadas;

        toReturn.inProgressRequests = this.getStatisticsChart(data.SolicitudesEnCurso, 'ClientName', 'Name', 'NormalUrgente');
        toReturn.totalInProgressRequests = data.TotalSolicitudesEncurso;

        toReturn.usersAndClientsLastMonthRequests = this.getStatisticsChart(data.SolicitudesPorUsuarioClienteUltimoMes,
            'ClientName', 'UserName');
        toReturn.totalUsersAndClientsLastMonthRequests = data.TotalSolicitudesPorUsuarioClienteMes;

        toReturn.pendingEnqueriesDigitalFisicalRequests = this.getStatisticsChart(data.SolicitudesConsultaDigitalFisicaPendientes,
            'ClientName', 'Name', 'NormalUrgente');
        toReturn.totalPendingEnqueriesDigitalFisicalRequests = data.TotalSolicitudesDigitalFisica;

        return toReturn;
    }

    private static getStatisticsChart(arrayValue: any[], propertyGroupBy: string, propertyCountName: string, secondPropertyCountName?: string): any {
        const statisticsChart: StatisticsChart[] = [];
        const groupByClients = this.getGroupBy(arrayValue, propertyGroupBy, propertyCountName);
        const keys = Object.keys(groupByClients);
        const clientsNumber = keys.length;
        if (clientsNumber > 1) {
            statisticsChart.push({
                client: -1,
                clientName: 'solicitudes.seleccione',
                isTwoDimenssions: true,
                results: this.createChartResults(groupByClients)
            });
        }
        keys.forEach(key => {
            const clientInformation = arrayValue.filter(x => x['Key'][propertyGroupBy] == key);
            let results: ChartResults[] | SeriesChart[];
            let isTwoDimenssions: boolean;
            if (secondPropertyCountName) {
                const groupByServiceName = this.getGroupBy(clientInformation, propertyCountName, secondPropertyCountName);
                results = this.createChartResults(groupByServiceName);
                isTwoDimenssions = true;
            } else {
                results = clientInformation.map(x => ({ name: x['Key'][propertyCountName], value: x.Counter }));
                isTwoDimenssions = false;
            }
            statisticsChart.push({
                client: clientInformation[0].Key.ClientId,
                clientName: clientInformation[0].Key.ClientName,
                isTwoDimenssions: isTwoDimenssions,
                results: results
            });
        });

        return statisticsChart;
    }

    private static createChartResults(groupByObject: any): ChartResults[] {
        const keys = Object.keys(groupByObject);
        return keys.map(key => this.createChartResult(key, groupByObject[key]));
    }

    private static createChartResult(name, value): ChartResults {
        const result = new ChartResults();
        const statisticKey = `nombresServicio.${name}`;
        const statisticName = Statistics.translateService.instant(statisticKey);
        result.name = statisticName !== statisticKey ? Statistics.translateService.instant(`nombresServicio.${name}`) : name;
        result.series = value.map(val => this.createSeriesChart(val));
        return result;
    }

    private static createSeriesChart(value): SeriesChart {
        const seriesChart = new SeriesChart();
        seriesChart.name = value.name;
        seriesChart.value = value.value;
        return seriesChart;
    }

    private static getGroupBy(arrayValue: any[], propertyGroupBy: string, propertyCountName: string): any {
        return arrayValue.reduce(function (obj, item) {
            const value = obj[item['Key'][propertyGroupBy]];
            if (!value) {
                obj[item['Key'][propertyGroupBy]] = [{ name: item['Key'][propertyCountName], value: item['Counter'] }];
            } else {
                const exactValue = value.find(val => val.name == item['Key'][propertyCountName]);
                if (exactValue) {
                    exactValue.value += item['Counter'];
                } else {
                    value.push({ name: item['Key'][propertyCountName], value: item['Counter'] });
                }
                obj[item['Key'][propertyGroupBy]] = value;
            }
            return obj;
        }, {});
    }
}



